import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "TrainingRegistrationLink" })
export default class TrainingRegistrationLink extends Vue {
    public localizer: any = Localizer;
    public isFormVisibile: boolean = false;

    @Prop() readonly trainingCourseIdMaster: string;
    @Prop() readonly returnUrl: string;
    @Prop() readonly trainingCourseTitle: string;
    @Prop() readonly isCompleted: boolean;

    get routes() {
        return (<any>window).App.routes;
    }

    public setIsFormVisible() {
        this.isFormVisibile = !this.isFormVisibile;
    }
};